import { render, staticRenderFns } from "./TeamPlanet.vue?vue&type=template&id=167e6563"
import script from "./TeamPlanet.vue?vue&type=script&lang=js"
export * from "./TeamPlanet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167e6563')) {
      api.createRecord('167e6563', component.options)
    } else {
      api.reload('167e6563', component.options)
    }
    module.hot.accept("./TeamPlanet.vue?vue&type=template&id=167e6563", function () {
      api.rerender('167e6563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/TeamPlanet.vue"
export default component.exports